import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
  container: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0
  },
  loginLoader: {
    marginLeft: theme.spacing(4)
  }
}))
